<template lang="pug">
div
  .row.flex-row-reverse(class="md: flex-row")
    .col-12.anim-fade(class="md:col-4")
      active-item
        .searchbar(slot-scope="{ setActive, active }")
          button.mt-12.btn.form-btn-outline-primary.block(class="md:hidden" @click.prevent="setActive(!active)") {{ translations.btn_mobile }}
          .searchbar__content(:class="{active: active}")
            .text-center.title--lg
              i.fas.fa-times-circle.mb-8.block(class="md:hidden" @click.prevent="setActive(!active)")
            h1.text-bold.text-center.block(class="md:hidden") {{ translations.h1 }}
            form(@submit.prevent="handleSubmit")
              .mt-0(class='md:mt-32')
                template(v-if='restaurant')
                  .mb-10
                    .form-label.mb-6 {{ translations.pricepicker }}
                    price-picker(
                      :translations="translations"
                      :place-prices="placePrices"
                      v-model="checkedPrices"
                    )

                  .mb-10
                    .form-label.mb-6 {{ translations.specialcriteria }}
                    special-criteria(
                      :translations="translations"
                      :place-criteria="placeCriteria"
                      v-model="selectedCriteria"
                    )

              .mb-10.h5.font-medium
                p-check(v-model="openedToday") {{ translations.openedToday }}

              .mb-10.h5.font-medium
                p-check(v-model="openedOnSunday") {{ translations.openedOnSunday }}

              .mb-10.h5.font-medium
                p-check(v-model="opened24") {{ translations.opened24 }}

              button.btn.btn-secondary.searchbar__submit(@click.prevent="setActive(!active)") {{ translations.submit }}

    list(
      :places="places"
      :translations="translations"
      :result="result"
      :opened-modal-place-id="openedModalPlaceId"
    )
      template(v-slot:placeholder="")
        slot(name="placeholder")

  b-pagination(
    v-if="totalRows > perPage"
    class="text-center anim-fade"
    v-model="currentPage"
    :total-rows="totalRows"
    :per-page="perPage"
    :hide-goto-end-buttons="true"
  )
</template>

<script>
import List from '@components/Place/List'
import axios from 'axios'

export default {
  components: {
    List
  },

  props: {
    buildings: {
      type: Array,
      required: true
    },

    buildingId: {
      type: Number,
      required: true
    },

    categoryId: {
      type: Number,
      required: true
    },

    restaurant: {
      type: Boolean,
      require: true
    },

    placePrices: {
      type: Array,
      required: true
    },

    placeCriteria: {
      type: Array,
      required: true
    },

    translations: {
      type: Object,
      default: () => ({})
    },

    params: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      places: [],
      checkedPrices: Array.isArray(this.params.by_price_ranges) ? this.params.by_price_ranges.map(price => parseInt(price)) : [],
      selectedCriteria: this.params.by_criteria !== undefined ? this.params.by_criteria : "",
      openedToday: this.params.opened_today === 'true',
      openedOnSunday: this.params.opened_on_sunday === 'true',
      opened24: this.params.opened_24 === 'true',
      result: null,
      currentPage: this.params.page || 1,
      totalRows: 1,
      perPage: this.params.per_page || 10,
      openedModalPlaceId: parseInt(this.params.opened_modal_place_id),
      locale: this.params.locale
    }
  },

  computed: {
    mutableProperties () {
      return (this.currentPage, this.checkedPrices, this.selectedCriteria, this.openedToday, this.openedOnSunday, this.opened24, Date.now())
    }
  },

  watch: {
    mutableProperties () {
      this.handleSubmit()
    }
  },

  created () {
    this.$eventBus.$on('reset-opened-modal-place-id', () => {
      this.openedModalPlaceId = null
    })

    this.handleSubmit()
  },

  methods: {
    handleSubmit () {
      axios.get('/api/v1/places', {
        params: {
          locale: this.locale,
          building_id: this.buildingId,
          category_id: this.categoryId,
          by_price_ranges: this.checkedPrices,
          by_criteria: this.selectedCriteria,
          opened_today: this.openedToday,
          opened_on_sunday: this.openedOnSunday,
          opened_24: this.opened24,
          per_page: this.perPage,
          page: this.currentPage,
          opened_modal_place_id: this.openedModalPlaceId
        }
      })
        .then(({ data, headers }) => {
          this.result = data.meta.result

          if (data.meta.building_category_location) {
            history.replaceState(null, null, data.meta.building_category_location)
          }

          this.totalRows = data.links.count

          this.places = data.data.map(place => {
            const buildingPlace = data.included.find(child => {
              return child.type === "building_place" &&
              child.attributes.place_id === Number(place.id) &&
              child.attributes.building_id === this.buildingId
            })

            place.attributes.description = buildingPlace.attributes.description
            place.attributes.access_html = buildingPlace.attributes.access_html

            return place
          })

          this.$nextTick(() => {
            this.$scrollTo('.places-list', 500, {
              offset: -50
            })
          })
        })
    }
  }
}
</script>
